import getUserLocale from 'get-user-locale';
export function formatHour(locale, hour) {
    return hour.toLocaleString(locale || getUserLocale() || undefined);
}
